import {
  registerReady
} from './ready'
import {
  registerCommand
} from './invoke'
import {
  publish
} from './publish'

const INSPECTOR_VARS = Object.create(null)

function getTarget(obj: object, dataPath: string): any {
  const parts = dataPath.split('.')
  let key = parts[0]
  if (parts.length === 1) {
    return obj[key]
  }
  return getTarget(obj[key], parts.slice(1).join('.'))
}

function getInspectorVar(dataPath: string): any {
  if (!INSPECTOR_VARS[dataPath]) {
    INSPECTOR_VARS[dataPath] = getTarget(document.querySelector('iframe').contentWindow, dataPath)
    if (!INSPECTOR_VARS[dataPath]) {
      throw new Error(dataPath + ' is undefined')
    }
  }
  return INSPECTOR_VARS[dataPath]
}

function normalizePath(url: string): string {
  return url.replace(/\\/g, '/')
}

function getUISourceCode(url: string): any {
  const uiSourceCode = getInspectorVar('Workspace.workspace').uiSourceCodeForURL(`uni-app:///${normalizePath(url)}`)
  if (!uiSourceCode) {
    console.error(`UISourceCode('${url}') is undefined`)
  }
  return uiSourceCode
}

function getUrl(url: string) {
  return url.replace('uni-app:///', '')
}

function breakpointAdded(evt: any): void {
  const uiLocation = evt.data.uiLocation
  const url = uiLocation.uiSourceCode.url()
  if (url.indexOf('uni-app:///') === 0) {
    publish('Debugger.breakpointAdded', {
      url: getUrl(url),
      enabled: evt.data.breakpoint.enabled(),
      lineNumber: uiLocation.lineNumber,
      columnNumber: uiLocation.columnNumber
    })
  }
}

function breakpointRemoved(evt: any): void {
  const uiLocation = evt.data.uiLocation
  const url = uiLocation.uiSourceCode.url()
  if (url.indexOf('uni-app:///') === 0) {
    publish('Debugger.breakpointRemoved', {
      url: getUrl(url),
      lineNumber: uiLocation.lineNumber,
      columnNumber: uiLocation.columnNumber
    })
  }
}

function setBreakpointByUrl({
  url,
  lineNumber
}) {
  const uniSourceCode = getUISourceCode(url)
  if(uniSourceCode){
    getInspectorVar('Common.Revealer').reveal(uniSourceCode.uiLocation(lineNumber,0))
    getInspectorVar('Bindings.breakpointManager').setBreakpoint(uniSourceCode, lineNumber, 0, '', true)
  } else {
    alert('本页面未在手机端运行，请在手机端打开本页面再同步断点。')
  }
}

function removeBreakpointByUrl({
  url,
  lineNumber
}) {
  const breakpoints = getInspectorVar('Bindings.breakpointManager').findBreakpoints(getUISourceCode(url), lineNumber)
  if (Array.isArray(breakpoints)) {
    breakpoints.forEach(breakpoint => {
      breakpoint.remove()
    })
  }
}

function debuggerPaused(evt: any) {
  const details = evt.data.debuggerPausedDetails()
  const selectedUILocation = details && details.callFrames.length ?
    getInspectorVar('Bindings.debuggerWorkspaceBinding').rawLocationToUILocation(details.callFrames[0].location()) :
    null
  //TODO 需要考虑 selectedUILocation 为 null
  if (selectedUILocation) {
    const url = selectedUILocation.uiSourceCode.url()
    if (url.indexOf('uni-app:///') === 0) {
      publish('Debugger.debuggerPaused', {
        url: getUrl(url),
        lineNumber: selectedUILocation.lineNumber,
        columnNumber: selectedUILocation.columnNumber
      })
    }
  }

}

function debuggerResumed(evt: any) {
  publish('Debugger.debuggerResumed')
}

function scriptParsed(evt: any) {
  const url = evt.data.url()
  if (url.indexOf('uni-app:///') === 0) {
    publish('Debugger.scriptParsed', {
      url: getUrl(url)
    })
  } else if (
    url.indexOf('webpack:///') === 0 ||
    url.indexOf('webpack-internal:///') === 0
  ) {
    // getInspectorVar('Bindings.blackboxManager').blackboxUISourceCode(
    //   getInspectorVar('Workspace.workspace').uiSourceCodeForURL(url)
    // )
  }
}

function ready() {
  // if(!getInspectorVar('Runtime').isLite){
  //   console.log('debugger is disabled')
  //   return
  // }
  console.log('debugger is ready')
  const Workspace = getInspectorVar('Workspace')
  Workspace.workspace.addEventListener(
    Workspace.Workspace.Events.UISourceCodeAdded,
    scriptParsed
  )

  const BreakpointManager = getInspectorVar('Bindings.BreakpointManager')
  const breakpointManager = getInspectorVar('Bindings.breakpointManager')
  breakpointManager.addEventListener(
    BreakpointManager.Events.BreakpointAdded,
    breakpointAdded
  )
  breakpointManager.addEventListener(
    BreakpointManager.Events.BreakpointRemoved,
    breakpointRemoved
  )

  const SDK = getInspectorVar('SDK')
  SDK.targetManager.addModelListener(
    SDK.DebuggerModel,
    SDK.DebuggerModel.Events.DebuggerPaused,
    debuggerPaused
  )
  SDK.targetManager.addModelListener(
    SDK.DebuggerModel,
    SDK.DebuggerModel.Events.DebuggerResumed,
    debuggerResumed
  )

}

registerReady(ready)

registerCommand('Debugger.setBreakpointByUrl', setBreakpointByUrl)
registerCommand('Debugger.removeBreakpointByUrl', removeBreakpointByUrl)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge/debugger.ts